import { Injectable } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormUtilsService {

  public markFormGroupTouched(formGroup: UntypedFormGroup): boolean {
    Object.keys(formGroup.controls).forEach((key) => {
      const control = formGroup.controls[key];
      control.markAsDirty();
      if ((control instanceof UntypedFormGroup)) {
        this.markFormGroupTouched(control);
      }
    });

    return formGroup.valid;
  }

  public getFormErrors(form: AbstractControl) {
    if (form instanceof UntypedFormControl) {
      // Return FormControl errors or null
      return form.errors ?? null;
    }
    if (form instanceof UntypedFormGroup) {
      const groupErrors = form.errors;
      // Form group can contain errors itself, in that case add'em
      const formErrors = groupErrors ? { groupErrors } : {};
      Object.keys(form.controls).forEach(key => {
        // Recursive call of the FormGroup fields
        const error = this.getFormErrors(form.get(key));
        if (error !== null) {
          // Only add error if not null
          formErrors[key] = error;
        }
      });
      // Return FormGroup errors or null
      return Object.keys(formErrors).length > 0 ? formErrors : null;
    }
  }

  public  merge(target: object, ...sources: object[])  {
    sources.forEach((source) => {
      return this.mergeValues(target, source)
    })
    return target
   }


   mergeValues(target: any, source: any) {
    if (typeof target === 'object' && typeof source === 'object') {
      return this.mergeObjects(target, source)
    }
    if (Array.isArray(target) && Array.isArray(source)) {
      return this.mergeArrays(target, source)
    }
    if (source === undefined) {
      return target
    }
    return source
   }

   mergeObjects(target: { [key: string]: any }, source:{ [key: string]: any }) {
    Object.keys(source).forEach((key) => {
      const sourceValue = source[key]
      const targetValue = target[key]
      target[key] = this.mergeValues(targetValue, sourceValue)
    })
   
    return target
   }

   mergeArrays(target: any[], source: any[]) {
    source.forEach((value, index) => {
      target[index] = this.mergeValues(target[index], value)
    })
   
    return target
   }

   
}
